import { computedAsync } from "@vueuse/core";
import {
  resolveMimeType,
  MimeType,
} from "@/globals/helpers/media/mimeTypeUtils";
import { IFile } from "@/modules/a.worksheets/stores/worksheetDataStore";
import { useDeviceStatus } from "@/stores/deviceStatus";
import { ComputedRef, Ref, toRefs } from "vue";
import { getFile, getLocalMediaFile } from "@/helpers/api";
import { url } from "@/stores/urls";
import { readFile } from "@/helpers/filesReadWrite";
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";


async function customReadFile(src: string) {
  const { data } = await Filesystem.readFile({
    path: src,
    encoding: Encoding.UTF8,
  });

  if (typeof data === "string") {
    const mimeTypeString = resolveBase64Type(data);
    const mimeType = resolveMimeType(mimeTypeString);

    return {
      uri: `${data}`,
      type: mimeType,
    };
  } else {
    const mimeType = resolveMimeType(data.type);
    const uri = URL.createObjectURL(data);
    return {
      uri: uri,
      type: mimeType,
    };
  }
}
function resolveBase64Type(base64: string): string {
  const type = base64.split(";")[0].split(":")[1];
  return type;
}

export interface IFileResolved {
  source: string;
  type: MimeType | undefined;
}

export const useIFileResolver = () => {
  async function resolveFile(
    file: IFile,
    isNetConnected: boolean
  ): Promise<IFileResolved | undefined> {

    const type = resolveMimeType(file.filetype);
    if (!type) {
      console.error("Error resolving mime type. File: ", file);
      return;
    }

    let src: string | null = null;
    if (isNetConnected && !file.isLocal) {
      console.log("resolving remote file");
      //src = (await getFile(file.filepath, file.filename, file.filetype)) ?? null;
      src = `${url.mediaURL}${file.filepath}/${file.filename}`;
    } else if(file.isLocal){
      console.warn(
        "trying to resolve inside useIFileResolver: ",
        file.filepath
      );
      const filepath = file.filepath;
      console.log("FETCHING FILE UNDER KEY: ", filepath);
      const result = await customReadFile(filepath);
      console.log("resolving local file with filepath: ", file.filepath);
      console.warn("resolved data: ", result);

      src = result.uri;
      // src = await getLocalMediaFile(
      //   file.filepath,
      //   file.filename,
      //   file.filetype
      // );
    }

    if (src) {
      return { source: src, type };
    } else {
      console.error("Error getting file source");
    }
  }

  async function resolvedFileArr(files: IFile[], isNetConnected: boolean) {
    const resolvedFiles: { source: string; type: MimeType | undefined }[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const resolved = await resolveFile(file, isNetConnected);
      console.log("resolved file: ", resolved);
      if (resolved) resolvedFiles.push(resolved);
    }

    return resolvedFiles;
  }

  const { isNetConnected } = toRefs(useDeviceStatus());
  const resolve = (
    file: ComputedRef<IFile | IFile[]> | Ref<IFile | IFile[]>,
    options?: { isNetConnected?: boolean }
  ): Ref<IFileResolved[] | undefined> => {
    return computedAsync<IFileResolved[]>(async () => {
      console.log("resolving file...");
      console.log("file: ", file.value);
      console.log("options: ", options);
      const resolvedFilesArr = await resolvedFileArr(
        Array.isArray(file.value) ? file.value : [file.value],
        options?.isNetConnected ?? isNetConnected.value
      );
      return resolvedFilesArr
    });
  };

  return {
    resolve,
    promise: {
      resolveFile
    }
  };
};
